// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentFieldPicker$ReactHooksTemplate = require("./ImportEnrichmentFieldPicker.res.js");
var ImportEnrichmentActionStyles$ReactHooksTemplate = require("./ImportEnrichmentActionStyles.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");
var ImportEnrichmentRuleValidation$ReactHooksTemplate = require("./ImportEnrichmentRuleValidation.res.js");

function ImportEnrichmentExtractBuilder(props) {
  var onUpdate = props.onUpdate;
  var sampleValue = props.sampleValue;
  var row = props.row;
  var preset = ImportEnrichmentActionHelpers$ReactHooksTemplate.currentExtractPreset(row);
  var showDelimiter = preset === "ExtractBeforeDelimiter" || preset === "ExtractAfterDelimiter";
  var showCustomPattern = preset === "ExtractCustom";
  var activePattern = ImportEnrichmentActionHelpers$ReactHooksTemplate.compileExtractPattern(row);
  var patternIsValid = ImportEnrichmentRuleValidation$ReactHooksTemplate.isRegexValid(activePattern, row.regexCaseSensitive);
  var workedExample = sampleValue !== undefined ? ImportEnrichmentActionHelpers$ReactHooksTemplate.extractWorkedExample(sampleValue, activePattern, row.regexGroup) : undefined;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                      fieldOptions: props.fieldOptions,
                      mode: "ReadablePath",
                      value: row.regexPath,
                      onChange: (function (v) {
                          var newrecord = Caml_obj.obj_dup(row);
                          Curry._1(onUpdate, (newrecord.regexPath = v, newrecord));
                        }),
                      placeholder: "Choose a text field"
                    }),
                row.regexMode === "Simple" ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: "Previously saved pattern",
                                className: "text-xs font-medium text-gray-600"
                              }),
                          JsxRuntime.jsx("p", {
                                children: ImportEnrichmentActionHelpers$ReactHooksTemplate.legacySimplePatternSummary(row),
                                className: "text-sm text-gray-800"
                              }),
                          JsxRuntime.jsx("button", {
                                children: "Switch to guided extraction",
                                className: "text-xs font-medium text-lochmara hover:text-blue-800",
                                type: "button",
                                onClick: (function (param) {
                                    Curry._1(onUpdate, ImportEnrichmentActionHelpers$ReactHooksTemplate.applyExtractPreset(row, "ExtractCustom"));
                                  })
                              })
                        ],
                        className: "rounded-lg border border-gray-200 bg-gray-50 p-3 space-y-2"
                      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("label", {
                                        children: "What should we extract?",
                                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                      }),
                                  JsxRuntime.jsxs("select", {
                                        children: [
                                          JsxRuntime.jsx("option", {
                                                children: ImportEnrichmentActionHelpers$ReactHooksTemplate.extractPresetLabel("ExtractFirstNumber"),
                                                value: "preset_number"
                                              }),
                                          JsxRuntime.jsx("option", {
                                                children: ImportEnrichmentActionHelpers$ReactHooksTemplate.extractPresetLabel("ExtractBeforeDelimiter"),
                                                value: "preset_before"
                                              }),
                                          JsxRuntime.jsx("option", {
                                                children: ImportEnrichmentActionHelpers$ReactHooksTemplate.extractPresetLabel("ExtractAfterDelimiter"),
                                                value: "preset_after"
                                              }),
                                          JsxRuntime.jsx("option", {
                                                children: ImportEnrichmentActionHelpers$ReactHooksTemplate.extractPresetLabel("ExtractCustom"),
                                                value: "preset_custom"
                                              })
                                        ],
                                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                                        value: ImportEnrichmentActionHelpers$ReactHooksTemplate.presetToMatchType(preset),
                                        onChange: (function (e) {
                                            var nextPreset = ImportEnrichmentActionHelpers$ReactHooksTemplate.matchTypeToPreset(e.target.value);
                                            var next = ImportEnrichmentActionHelpers$ReactHooksTemplate.applyExtractPreset(row, nextPreset);
                                            var tmp;
                                            if (nextPreset === "ExtractBeforeDelimiter" || nextPreset === "ExtractAfterDelimiter") {
                                              var newrecord = Caml_obj.obj_dup(next);
                                              newrecord.regexPattern = ImportEnrichmentActionHelpers$ReactHooksTemplate.compilePresetPattern(next);
                                              tmp = newrecord;
                                            } else {
                                              tmp = next;
                                            }
                                            Curry._1(onUpdate, tmp);
                                          })
                                      })
                                ]
                              }),
                          showDelimiter ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("label", {
                                          children: preset === "ExtractBeforeDelimiter" ? "Stop before this character" : "Start after this character",
                                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                        }),
                                    JsxRuntime.jsx("input", {
                                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                                          placeholder: preset === "ExtractBeforeDelimiter" ? "e.g. -" : "e.g. :",
                                          value: row.regexBuilderText,
                                          onChange: (function (e) {
                                              var value = e.target.value;
                                              var newrecord = Caml_obj.obj_dup(row);
                                              newrecord.regexBuilderText = value;
                                              var newrecord$1 = Caml_obj.obj_dup(newrecord);
                                              Curry._1(onUpdate, (newrecord$1.regexPattern = ImportEnrichmentActionHelpers$ReactHooksTemplate.compilePresetPattern(newrecord), newrecord$1));
                                            })
                                        })
                                  ]
                                }) : null,
                          showCustomPattern ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: "Advanced",
                                          className: "text-xs font-semibold text-gray-500 uppercase tracking-wide"
                                        }),
                                    JsxRuntime.jsx("label", {
                                          children: "Custom pattern",
                                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                        }),
                                    JsxRuntime.jsx("input", {
                                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase + " font-mono text-xs",
                                          placeholder: "e.g. ORD-(\\d+)",
                                          value: row.regexPattern,
                                          onChange: (function (e) {
                                              var newrecord = Caml_obj.obj_dup(row);
                                              Curry._1(onUpdate, (newrecord.regexPattern = e.target.value, newrecord));
                                            })
                                        }),
                                    JsxRuntime.jsxs("label", {
                                          children: [
                                            JsxRuntime.jsx("input", {
                                                  checked: row.regexCaseSensitive,
                                                  type: "checkbox",
                                                  onChange: (function (e) {
                                                      var newrecord = Caml_obj.obj_dup(row);
                                                      Curry._1(onUpdate, (newrecord.regexCaseSensitive = e.target.checked, newrecord));
                                                    })
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  className: "checkbox cursor-pointer"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: "Match case exactly",
                                                  className: "ml-2"
                                                })
                                          ],
                                          className: "flex items-center text-xs cursor-pointer text-gray-600"
                                        })
                                  ],
                                  className: "space-y-2 border border-gray-200 rounded-lg p-3 bg-gray-50"
                                }) : null,
                          workedExample !== undefined ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("p", {
                                          children: "Example",
                                          className: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: workedExample,
                                          className: "text-sm text-gray-800"
                                        })
                                  ],
                                  className: ImportEnrichmentActionStyles$ReactHooksTemplate.previewBoxClass
                                }) : null,
                          JsxRuntime.jsx("p", {
                                children: activePattern === "" ? "Complete the fields above to finish setup." : (
                                    patternIsValid ? "Extraction setup looks valid." : "Enter a valid extraction setup."
                                  ),
                                className: "text-xs " + (
                                  patternIsValid && activePattern !== "" ? "text-green-600" : "text-gray-500"
                                )
                              })
                        ]
                      })
              ],
              className: "space-y-3"
            });
}

var make = ImportEnrichmentExtractBuilder;

exports.make = make;
/* react/jsx-runtime Not a pure module */
